import React, { useState, useEffect } from "react";
import "./Charts.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../Components/HamburgerMenu/HamburgerMenu";
import "chart.js/auto";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import SelectOptions from "../../Components/SelectOptions/SelectOptions";
import sizeData from "./sizeData";
import BottomBar from "../../Components/BottomBar/BottomBar";
import { useBaseUrl } from "../../ApiContext";
import CurveChart from "./CurveChart";

export default function Charts() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [calorieChartData, setCalorieChartData] = useState([]);
  const [sizeChartData, setSizeChartData] = useState([]);
  const [weightChartData, setWeightChartData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const selectHandler = (size) => {
    const mainObjectLabel = sizeData.filter((item) => item.id === size.id)[0]
      .label;
    setSelectedOption(mainObjectLabel);
  };
  useEffect(() => {
    const fetchGraph = async () => {
      try {
        const response = await Axios.get(`${baseUrl}/report/diet_plan/graph`, {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        });
        const graphData = response.data.data;
        setCalorieChartData(graphData);
      } catch (error) {
        console.log("Error during getting calories graph", error);
      }
    };
    const fetchWeightLossGraph = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/weight_loss/graph`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setWeightChartData(response.data.data);
      } catch (error) {
        console.log("Error during getting weight loss graph", error);
      }
    };
    if (userToken) {
      fetchGraph();
      fetchWeightLossGraph();
    }
  }, [baseUrl, userToken]);

  useEffect(() => {
    const fetchWeightChangeGraph = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/weight_change_graph`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        let selectedData = response.data.data.map((item) => ({
          date: item.date,
          value: parseFloat(item[selectedOption]) || 0,
        }));
        setSizeChartData(selectedData);
      } catch (error) {
        console.log("Error during getting weight change graph", error);
      }
    };
    if (userToken) {
      fetchWeightChangeGraph();
    }
  }, [baseUrl, userToken, selectedOption]);

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <div className="chartsWrapper scroll">
            <div className="calorieChart horizontalBorder">
              <h3 className="chartsTitle">نمودار تغییرات کالری</h3>
              {calorieChartData.length > 0 && (
                <CurveChart
                  chartData={calorieChartData}
                  xDataKey="weekday"
                  valueDataKey="calories"
                  chartType="calorie"
                />
              )}
            </div>
            <div className="weeklyWeightChart horizontalBorder">
              <h3 className="chartsTitle">نمودار وزن هفتگی</h3>
              <CurveChart
                chartData={weightChartData}
                xDataKey="date"
                valueDataKey="weight"
                chartType="weight"
              />
            </div>
            <div className="monthlySizeChart horizontalBorder">
              <h3 className="chartsTitle">نمودار سایز ماهانه</h3>
              <SelectOptions
                optionsData={sizeData.map((size) => ({
                  id: size.id,
                  name: size.name,
                }))}
                onSelect={(item) => selectHandler(item)}
              />
              <CurveChart
                chartData={sizeChartData}
                xDataKey="date"
                valueDataKey="value"
                chartType="size"
              />
            </div>
          </div>
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
